<div class="py-2.5 px-7">
  <app-section-header
    [title]="profileName"
    [isBackBtnShown]="true"
    [preserveQueryParam]="true"
  >
  </app-section-header>
  <div *ngIf="managerProfile">
    <app-profile-status-card
      [content]="managerProfile"
      [isSaving]="isSaving"
      [isBioPopulated]="this.form.valid"
      (handleSave)="onSave()"
      class="px-4"
    ></app-profile-status-card>
  </div>
  <div class="pt-2.5 border-b border-project-200">
    <mat-tab-group>
      <mat-tab *ngFor="let formItem of form.controls | keyvalue">
        <ng-template mat-tab-label>{{ languageMap[formItem.key] }}</ng-template>
        <mat-form-field
          class="w-full"
          [floatLabel]="'never'"
          appearance="outline"
        >
          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            matAutosizeMaxRows="20"
            cdkAutosizeMinRows="10"
            [formControl]="formItem.value"
            [readonly]="!isEditing"
          ></textarea>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
